// @flow

/**
 * isEmail regex.
 */

const email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * `isNumber` regex.
 */

const number = /[^0-9]+/g;

/**
 * Export regexes.
 */

export const regex = {
  email,
  number
};



// WEBPACK FOOTER //
// ../src/client/core/utils/regexes.js